module.exports = __webpack_public_path__ + "img/0a0bb6a.jpg";